import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Spin } from "antd";


// Lazy load components
const HomePage = React.lazy(() => import("../components/website"));

// Centered loader component
const CenteredLoader = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
    }}>
        <Spin size="large" />
    </div>
);

// Website Routes - Only website landing page
function WebsiteRoutes() {
    return (
        <Suspense fallback={<CenteredLoader />}>
            <Routes>
                {/* Website Home Page - Root Route */}
                <Route path="/" element={<HomePage />} />

                {/* Catch all - redirect to website */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Suspense>
    );
}

export default WebsiteRoutes;